<template>
    <div class="page">
        <p>
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br />
            Date: {{ date }}
            <br />
            <br />
                RE: Notice of complaints filed for repeated violation of my consumer rights and the FDCPA
            <br />
            RE: Account: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
            <br />
            <br />
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            This letter is to notify you that I have officially filed a complaint against your company with the Federal Trade Commission, the US Attorney General, and the Better Business Bureau due to your blatant disregard for my consumer rights per the Fair Debt Collection Practices Act. For your convenience, I've attached a copy of my complaint letter, proof that the complaints have in fact been filed, as well as copies of all supporting documents/correspondence I've made with your company.
        </p>
        <p class="letter-content">
            I have been requesting, since <strong>[MONTH/YEAR]</strong>, debt validation for the alleged debts you claim I owe to your company and which you are reporting on my credit files. However, your company has failed to obtain and send me legal validation from the original creditor as mandated by the Fair Debt Collection Practices Act. Furthermore, I have requested verification and validation, several times, directly through each of the Credit Reporting Repositories and each time they have reported that you electronically verified the accuracy of these alleged claims through their automated systems, yet you failed to do so for me ... why is that. Thus, you have failed to cease collection activity until validation of debt has been made by continuing to report inaccurate and unverifiable information to these Credit Reporting Agencies as prohibited by the Fair Debt Collections Practices Act. Therefore, it is quite obvious that you have deliberately violated my rights in more than one way which is punishable by law.
        </p>
        <p class="letter-content">
            With that being said, please let it be known that this is not another request for debt validation. You have had more than enough time and chances to comply with the law. So due to your repeated and blatant disregard for the law, I have already filed complaints against your company and my attorney will be, within the next fifteen (15) days, filing a civil suit against you as well as a claim against your surety bond for the maximum in punitive damages and fines allowable by law.
            <br />
            <br />
            I've had enough of your company violating my rights and hopefully, this legal action will prevent you from operating in this manner against others.
        </p>
        <p>
            Sincerely,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>